import { Observable } from "rxjs/Observable";
import { Response, ResponseOptions } from "@angular/http";
import { VASRestService } from "../../api/vas-rest";
import { ChangeQItem } from "../item";
import { OperationResult } from "../operation-result";
import { Account } from "../../../../vas/business-objects/account/account.model";
import { fromPromise } from "rxjs/observable/fromPromise";
import { VasAppFacade } from "../../../../vas/services/vas-app-facade.service";
import { entityFactory } from "../../../helpers/entity-factory";

export abstract class Operation {

    constructor(public item: ChangeQItem, protected restService: VASRestService, protected appFacade: VasAppFacade) {

    }

    getItem(): ChangeQItem {
        return this.item;
    }

    sync(): Observable<OperationResult> {

        let subscription;

        switch (this.item.method) {
            case "POST": {
                subscription = this.post();
                break;
            }
            case "PATCH": {
                subscription = this.patch();
                break;
            }
            case "DELETE": {
                subscription = this.delete();
                break;
            }
            case "REFRESH": {
                subscription = this.refresh();
                break;
            }
            default: {
                throw Error(`invalid method ${this.item.method}`);
            }
        }

        return this._sync(subscription);
    }

    _sync(subscription: Observable<Response>): Observable<OperationResult> {
        return subscription
            .catch((response, o) => {
                return Observable.of(new OperationResult(this.item, response));
            })
            .map((result: Response | OperationResult) => {

                if (!result) {
                    return new OperationResult(this.item, new Response(new ResponseOptions({status: 200})));
                } else if (result instanceof Response) {
                    return new OperationResult(this.item, result);
                } else {
                    return result as OperationResult;
                }
            });
    }

    post(): Observable<Response> {

        switch (this.item.entity) {
            case "account": {
                return this.getRestService().postAccount(new Account(this.item.data));
            }
            case "user": {
                // @todo
                return Observable.throw(Error("postUser not implemented"));
            }
            // @todo Does this case make sense?
            case this.item.parentId: {
                return this.getRestService().postAccountObjectSubResource(
                    this.item.account,
                    "job",
                    this.item.parentId,
                    this.item.entity,
                    this.item.data
                );
            }
            default: {
                if (this.item.parentId) {
                    return this.getRestService().postAccountObjectSubResource(
                        this.item.account,
                        "job",
                        this.item.parentId,
                        this.item.entity,
                        this.item.data
                    );
                }

                return this.getRestService().postAccountObject(
                    this.item.entity,
                    this.item.account,
                    this.item.data
                );
            }
        }
    }

    patch(): Observable<Response> {

        switch (this.item.entity) {
            case "account": {
                return this.getRestService().patchAccount(
                    this.item.account,
                    this.item.data
                );
            }
            case "user": {
                return this.getRestService().patchUser(
                    this.item.id,
                    this.item.data as any
                );
            }
            // @todo Does this case make sense?
            case this.item.parentId: {
                return this.getRestService().patchAccountObjectSubResource(
                    this.item.account,
                    "job",
                    this.item.parentId,
                    this.item.entity,
                    this.item.id,
                    this.item.data,
                    this.item.version
                );
            }
            default: {
                if (this.item.parentId) {
                    return this.getRestService().patchAccountObjectSubResource(
                        this.item.account,
                        "job",
                        this.item.parentId,
                        this.item.entity,
                        this.item.id,
                        this.item.data,
                        this.item.version
                    );
                }

                return this.getRestService().patchAccountObject(
                    this.item.entity,
                    this.item.account,
                    this.item.id,
                    this.item.data,
                    this.item.version
                );
            }
        }
    }

    delete(): Observable<Response> {

        switch (this.item.entity) {
            case "account": {
                // @todo
                return Observable.throw(Error("deleteAccount not implemented"));
            }
            case "user": {
                // @todo
                return Observable.throw(Error("deleteUser not implemented"));
            }
            // @todo Does this case make sense?
            case this.item.parentId: {
                return this.getRestService().deleteAccountObjectByIdSubResource(
                    this.item.account,
                    "job",
                    this.item.parentId,
                    this.item.entity,
                    this.item.id
                );
            }
            default: {
                if (this.item.parentId) {
                    return this.getRestService().deleteAccountObjectByIdSubResource(
                        this.item.account,
                        "job",
                        this.item.parentId,
                        this.item.entity,
                        this.item.id
                    );
                }

                return this.getRestService().deleteAccountObjectById(
                    this.item.entity,
                    this.item.account,
                    this.item.id
                );
            }
        }
    }

    refresh(): Observable<Response> {

        const instance = entityFactory(this.item.entity, this.item.data);

        return this.appFacade.objects
            .syncObject(instance)
            .map(() => new Response(new ResponseOptions({status: 200})));
    }

    getRestService(): VASRestService {
        return this.restService;
    }

}



// WEBPACK FOOTER //
// ./src/core/services/sync-up/operations/operation.ts